module.exports = __webpack_public_path__ + "static/media/current-status-complete.e12655bb.jpg";